/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgShieldOff(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <g>
        <path
          fill='currentColor'
          fillRule='evenodd'
          d='M.47.47a.75.75 0 011.06 0l3.72 3.718a.752.752 0 01.022.024l12.875 12.875.007.007 5.376 5.376a.75.75 0 11-1.06 1.06l-4.832-4.83a21.039 21.039 0 01-5.288 3.963.75.75 0 01-.685.008L12 22l-.335.67h-.003l-.006-.004-.02-.01-.074-.038a20.806 20.806 0 01-1.209-.7 22.438 22.438 0 01-2.847-2.104C5.461 18.025 3.25 15.334 3.25 12V5a.75.75 0 01.19-.5L.47 1.53a.75.75 0 010-1.06zm4.28 5.34V12c0 2.665 1.789 4.975 3.744 6.686a20.94 20.94 0 003.504 2.462 19.536 19.536 0 004.58-3.51L4.75 5.811zm6.988-4.513a.75.75 0 01.525 0l8 3A.75.75 0 0120.75 5v7.005c-.005.752-.12 1.5-.344 2.217a.75.75 0 11-1.432-.444 6.148 6.148 0 00.276-1.78V5.52L12 2.8 9.101 3.884a.75.75 0 01-.524-1.406l3.16-1.18z'
        />
      </g>
      <defs>
        <clipPath id='shield-off_svg__clip0_126_10473'>
          <path fill='#fff' d='M0 0h24v24H0z' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgShieldOff;
